export default function DepartmentsFilter (incomingarray, incomingdata){
    let arrayIDs = []
    incomingarray.allDepartments.map(Objvalue => (
        arrayIDs.push(Objvalue.ID)
    ))

    if(arrayIDs.includes(incomingdata)){
        let Filteredepart = incomingarray.allDepartments.filter(Objvalue => {
            return Objvalue.ID === incomingdata
        })
        return Filteredepart[0].name
    } else{
        return 'Administrator'
    }
}

export function CountriesFilter (incomingarray, incomingdata){
    let arrayIDs = []
    incomingarray.allCountries.map(Objvalue => (
        arrayIDs.push(Objvalue.ID)
    ))

    if(arrayIDs.includes(incomingdata)){
        let countryfilter = incomingarray.allCountries.filter(Objvalue => {
            return Objvalue.ID === incomingdata
        })
        return countryfilter[0].name
    } else{
        return 'Administrator'
    }
}

export function StaffFilter (incomingarray, incomingdata){
    let staffilter
    let arrayIDs = []
    incomingarray.allStaffs.map(Objvalue => (
        arrayIDs.push(Objvalue.ID)
    ))

    console.log(arrayIDs)

    if(arrayIDs.includes(incomingdata)){
        staffilter = incomingarray.allStaffs.filter(Objvalue => {
            return Objvalue.ID === incomingdata
        })
        return staffilter[0].first_name + ' ' + staffilter[0].last_name
    } else{
        return 'Administrator'
    }
}




